import Navbar from "../global/Navbar";
import { useParams } from "react-router-dom";
import { useState } from "react";
import TeacherTraning from "../components/testLearning/TeacherTraning";
import LiveCoach from "../components/testLearning/LiveCoach";

const TestLearning = () => {
  
      const { name } = useParams();
  const decodedCourseName = decodeURIComponent(name);
  const [active,setActive] = useState(decodedCourseName);

   const render = () => {
    switch (active) {
      
      case "teacher-traning":
        return <TeacherTraning/>;

      case "live-coaching":
        return <LiveCoach/>;
        
      default:
        return <h1>Default View</h1>;
    }
  };
  return (
      <div className="w-full flex flex-col justify-center items-center bg-[#101e2b]">
      <Navbar />
      <div className="container flex flex-col gap-4 px-4 lg:px-0">
        <div className="mt-[2rem] flex items-center justify-center gap-4 border-b border-[#22BEFF33]">
           
            <button className={`font-bold text-base cursor-pointer pb-2 ${active === "teacher-traning" ? "border-b-2 border-[#22BEFF] text-[#22BEFF]":"text-gray-300"}`} onClick={()=>setActive('teacher-traning')}>TEACHER TRANING</button>
           
           
            <button className={`font-bold text-base cursor-pointer pb-2 uppercase ${active === "live-coaching" ? "border-b-2 border-[#22BEFF] text-[#22BEFF]":"text-gray-300"}`} onClick={()=>setActive('live-coaching')}>Life Coach Training</button>

        </div>
        <div className="mt-[2rem]">
          {render()}
        </div>
      </div>
    </div>
  )
}

export default TestLearning